/**
 * Shim for @clariness/flex: re-exports with optional placeholder/onPointer* props
 * so React 19 types don't require them (theme-ui Pick<> types treat them as required).
 */
import React from 'react';
import { Flex as OrigFlex, type FlexProps } from '~clariness-flex';

type OptionalPointerProps = {
  placeholder?: string;
  onPointerEnterCapture?: React.PointerEventHandler;
  onPointerLeaveCapture?: React.PointerEventHandler;
};

export type { FlexProps };
export const Flex = OrigFlex as React.ForwardRefExoticComponent<
  Omit<React.ComponentProps<typeof OrigFlex>, keyof OptionalPointerProps> &
    OptionalPointerProps &
    React.RefAttributes<HTMLDivElement>
>;
